import { z } from "zod";

export const createOneTimePasscode = {
  input: z.object({ email: z.string(), teamId: z.string() }),
  output: z.object({ fourDigitCodeId: z.string() }),
};
